"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.translations = void 0;
const en_1 = __importDefault(require("./en"));
const es_1 = __importDefault(require("./es"));
const it_1 = __importDefault(require("./it"));
const pl_1 = __importDefault(require("./pl"));
const zh_1 = __importDefault(require("./zh"));
const de_1 = __importDefault(require("./de"));
exports.translations = {
    en: en_1.default,
    pl: pl_1.default,
    es: es_1.default,
    it: it_1.default,
    zh: zh_1.default,
    de: de_1.default
};
